import api from '@/os/APIs/priceAPI';

export default {
  install: (app) => {
    // eslint-disable-next-line no-param-reassign
    app.config.globalProperties.$prices = api;
  },
};
